import request from '@/utils/request'
import $md5 from 'js-md5'
import { randomString, toHex } from './Global'
import { sm2, sm4 } from 'sm-crypto'
import store from '../store'


export default function encryptReq(url, data, headers = {}) {
  const nonStr = randomString(10)
  const key = toHex(randomString(16))
  const iv = toHex(randomString(16))
  const src = JSON.stringify(data)
  const encrypted = sm4.encrypt(src, key, { mode: 'cbc', iv: iv })
  let pubKey = store.getters.commonInfo.pubKey
  let enSrc = iv + '|' + key
  console.log(sm2)
  const enKey = '04' + sm2.doEncrypt(enSrc, pubKey, 1);
  // const enKey = '11'
  const timestamp = new Date().getTime()
  const sign = $md5(encrypted + iv + key + nonStr + timestamp)
  const form = {
    data: encrypted,
    key: enKey,
    nonStr: nonStr,
    timestamp: timestamp,
    sign: sign
  }
  headers['Content-type'] = 'application/json'
  return request({
    url: url,
    method: 'post',
    data: JSON.stringify(form),
    headers: headers
  })
}
